import React from 'react';
import Icon from './wrong.svg';

const WrongIcon = ({height='20px', width='20px', color='white'}) => {
	return <Icon height={height} width={width} color={color} aria-label="Incorrect" />;
};

export default WrongIcon;
